import { createContext } from 'react';

export const FarmerEditInventoryContext = createContext(null);
